import React from "react";
import { Skeleton } from "../../ui/skeleton";

export function PageLoader() {
  return (
    <div className="flex h-screen w-full flex-col">
      <div className="border-b border-grey-200 dark:border-grey-800 p-4">
        <Skeleton className="h-12 w-48 mb-2" />
        <Skeleton className="h-8 w-32" />
      </div>

      <div className="flex-1 p-6 space-y-4">
        <Skeleton className="h-10 w-64 mb-6" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    </div>
  );
}
